import InstructionDialog from "../home/InstructionDialog";
import { Icon } from "@iconify/react";
import IconButton from "../basic/IconButton";
import AddToPlaylistDialog from "./AddToPlaylistDialog";
import ic_calories from "../../assets/icons/ic_calories.svg";
import React, { Fragment, useState } from "react";
import { toast } from "react-toastify";
import {
  BlueTextLinearGradient,
  capitalize,
  isSubscriptionExpired,
  WhiteLinearGradient,
} from "../../utils/Utils";
import { deleteUserPlaylistExercise } from "../../api/api";
import PlanExpiredDialog from "../subscription/PlanExpiredDialog";
import { useAuthContext } from "../../context/AuthContext";
import { useAppContext } from "../../context/AppContext";
import ShareDialog from "../home/ShareDialog";

export function SkeletonExerciseList({ numberOfExercise }) {
  const Skeleton = () => {
    return (
      <div className=" shadow-2xl rounded-xl  max-w-sm w-full mx-auto">
        <div className="animate-pulse flex flex-col">
          <div className="bg-slate-200 space-y-5 rounded-xl h-[200px] p-5 flex flex-col justify-center items-center">
            <div className="flex w-full items-end justify-end">
              <div className="h-10 w-10 rounded-full bg-slate-400  "></div>
            </div>
            <div className="flex flex-1 w-full justify-center items-center">
              <div className="h-6 rounded-xl bg-slate-400  w-2/3 flex"></div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="my-14">
      {[...Array(numberOfExercise || 3).keys()].map((item) => {
        return (
          <div className="animate-pulse flex flex-col">
            <div className="space-y-5 flex flex-col ">
              <div className="h-6 rounded-xl bg-slate-400  w-1/5"></div>
              <div className="gap-5 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 items-center justify-center">
                <Skeleton />
                <Skeleton />
                <Skeleton />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function UserPlaylistExerciseCard({
  playlistId,
  exerciseId,
  exerciseName,
  description,
  exerciseImage,
  exerciseUri,
  allowStart,
  exerciseUrl,
  onExerciseDelete,
  canDelete,
  allowShare = true,
}) {
  const deleteExercise = async () => {
    const response = await deleteUserPlaylistExercise(playlistId, exerciseId);
    if (response && response.success) {
      toast("Exercise Deleted", { type: "success" });
      onExerciseDelete();
    } else {
      toast("Error deleteing exercise", { type: "error" });
    }
  };
  const appState = useAppContext();

  return (
    <div className="w-full flex flex-row justify-center items-start h-full space-x-4">
      <img src={exerciseImage} className="h-20 w-32 object-cover rounded-lg" />
      <div className="flex flex-1 flex-col ">
        <p className="font-bold text-lg text-black dark:text-primary-white flex flex-1 items-end uppercase">
          {exerciseName}
        </p>
        <p className="font-medium  text-black dark:text-primary-white flex flex-1 items-end">
          {description}
        </p>
      </div>
      {canDelete && (
        <div
          className="flex flex-row items-center hover:cursor-pointer"
          onClick={() => {
            deleteExercise();
          }}
        >
          <Icon
            icon={"ant-design:delete-outlined"}
            color={appState.state.darkMode ? "#fff" : "#000"}
            className="w-5 h-5"
          />
        </div>
      )}
    </div>
  );
}

export function ExerciseCard({
  id,
  exerciseName,
  details,
  description,
  badgeText,
  addToPlaylist = true,
  exerciseImage,
  exerciseUri,
  allowStart,
  exerciseVideo,
  exerciseAudio,
  exerciseUrl,
  showInstructionBeforeRedirect,
  onUserPlaylistUpdate,
  selectedExercises,
  setSelectedExercise,
}) {
  const [showInstruction, setShowInstruction] = useState(false);
  const [showAddToPlaylist, setShowAddToPlaylist] = useState(false);
  const auth = useAuthContext();
  return (
    <div className="group w-full min-h-[300px] max-h-full flex flex-1 justify-center items-center  z-0">
      {auth.state.user && isSubscriptionExpired(auth.state.user?.expiresAt) ? (
        <PlanExpiredDialog
          show={showInstruction}
          close={() => {
            setShowInstruction(false);
          }}
        />
      ) : (
        <InstructionDialog
          show={showInstruction}
          close={() => setShowInstruction(false)}
          redirectUrl={`${exerciseUrl}`}
          allowDontShow={true}
        />
      )}
      <AddToPlaylistDialog
        exerciseIdList={[id]}
        open={showAddToPlaylist}
        close={() => {
          setShowAddToPlaylist(false);
        }}
        onUserPlaylistUpdate={() => {}}
      />
      <div
        className={`transform w-full h-full bg-gray-900  transition-all ${
          allowStart
            ? "cursor-pointer hover:scale-110 hover:z-10 relative ease-in-out overflow-clip duration-500"
            : ""
        }   rounded-xl`}
      >
        <img
          src={exerciseImage}
          className="absolute h-full object-cover w-full"
        />
        <div
          className={`h-full relative bg-cover overflow-clip rounded-xl flex justify-center items-center flex-col `}
          onClick={() => {
            if (allowStart) setShowInstruction(true);
          }}
        >
          <div className="bg-black bg-opacity-60 p-2 md:p-4 h-full w-full flex flex-col rounded-xl">
            <div className="flex w-full self-end items-center gap-2">
              {/* <img src={ic_calories} />
              <p className="text-white text-sm">317 kCal</p> */}
              <div className="flex-1" />
              <IconButton
                iconComponent={
                  <Icon
                    icon="carbon:overflow-menu-vertical"
                    className="flex md:h-6 md:w-6 text-white "
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowAddToPlaylist(true);
                    }}
                  />
                }
                // className="bg-opacity-60 justify-center h-7 w-7  z-10"
                className="bg-[#111525] bg-opacity-50 justify-center h-7 w-7  z-10"
              />
            </div>
            <div className="flex flex-1 items-end  w-full">
              <div className="flex w-full items-center">
                <p
                  className={`font-bold font-poppins text-xl md:text-2xl text-white flex flex-1 items-end`}
                >
                  {capitalize(exerciseName)}
                </p>
                {/* <Icon
                  icon="mdi:cards-heart"
                  className="flex md:h-7 md:w-7 text-white opacity-70 "
                  onClick={(e) => {
                    e.stopPropagation();
                    <Icon
                      icon="mdi:cards-heart"
                      className="flex md:h-7 md:w-7 text-red-900 "
                    />;
                  }}
                /> */}
              </div>
            </div>
          </div>

          <p className="text-white font-open-sans w-full text-center rounded-b-xl bg-black-200 text-sm font-bold p-3">
            Start Exercise
          </p>
        </div>
      </div>
    </div>
  );
}

export const MemoizedExerciseList = React.memo(ExerciseList);

export function ExerciseList({
  title,
  exerciseList,
  initialOpen,
  showInstructionBeforeRedirect,
  selectedExercises,
  setSelectedExercise,
  onUserPlaylistUpdate,
}) {
  return (
    <div className="my-14 ">
      <p
        className={`${BlueTextLinearGradient} font-poppins font-medium text-left text-2xl z-0`}
      >
        {title}
      </p>
      <div className="flex flex-row items-center space-x-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5  flex-1 gap-4 mt-5">
          {exerciseList.map((exercise, index) => {
            return (
              <ExerciseCard
                {...exercise}
                key={index}
                onUserPlaylistUpdate={onUserPlaylistUpdate}
                allowStart
                showInstructionBeforeRedirect
                selectedExercises={selectedExercises}
                setSelectedExercise={setSelectedExercise}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
